export default __webpack_public_path__ + "static/ilie-mihalache-3dc44e2ab264fd1e25bc6a8fbb1f6c82.svg";